import { MEMBERS_INVALIDATION_DOMAIN } from '@rentguru/commons-utils';

import { useInvalidationBus } from './useInvalidationBus';
import { useUser } from './UserContext';

const SessionRevocationListener = () => {
  const { revalidateSession } = useUser();
  useInvalidationBus((message) => {
    if (message.domains.includes(MEMBERS_INVALIDATION_DOMAIN)) {
      revalidateSession();
    }
  });
  return null;
};

export default SessionRevocationListener;
